import React from 'react';
import { ACTIVITY_TYPES_ICONS } from '../../../Utils/constants/activityTypes';
import Dialog from '..';
import ManualActivityForm from './ManualActivityContent';

const ManualActivityDialog = function ManualActivityDialog({
  open,
  onClose,
  onSubmit,
}) {
  const Icon = ACTIVITY_TYPES_ICONS.MANUAL;

  // eslint-disable-next-line no-unused-vars
  const handleSubmit = ({ activityOutcome, ...data }) => {
    onSubmit(data);
  };

  return (
    <Dialog
      id="manual-activity-dialog"
      title="INSERT_MANUAL_ACTIVITY"
      icon={<Icon />}
      open={open}
      onClose={onClose}
      onCancel={onClose}
      onSubmit={handleSubmit}
      width="sm"
      fullWidth
      disableScroll
      form
      dividers
    >
      <ManualActivityForm />
    </Dialog>
  );
};

export default ManualActivityDialog;
